import './index.scss'
import React, {useEffect, useState} from "react";
import Service from "../../service";
const GetFragmentsModal = ({ onClose, successCallBack, data }) => {
  const handleKnow = () => {
    onClose()
    successCallBack && successCallBack()
  }
  return (
    <div className="get-fragments-modal">
      <div className="get-fragments-container">
        <div className="get-fragments">
          <div className="get-fragments-title">恭喜抽中</div>
          <div className={data?.length > 1 ? 'get-fragments-img-box' : 'get-fragments-one-img-box'}>
            {data?.length  > 0 && data.map((item, index) => {
              return (
                <div key={index} className="get-fragments-img-item">
                  <img className="get-fragments-img" src={item?.imgUrl || require('../../imgs/lion.png')} alt="" />
                  {item?.count > 0 && <div className="get-fragments-count">{item.count}</div>}
                </div>
              )
            })}
          </div>
          <button className="get-fragments-btn" onClick={handleKnow}>我知道了</button>
        </div>
      </div>
    </div>
  )
}
export default GetFragmentsModal